// extracted by mini-css-extract-plugin
module.exports = {"xs":"375px","sm":"600px","md":"834px","lg":"1280px","xl":"1280px","wrapper":"ShareRafPass-module__wrapper___39gXH","rafPassImg":"ShareRafPass-module__rafPassImg___azPfj"};